import { createFileRoute } from '@tanstack/react-router'
import Profile from '@/components/protected/profile/Profile'
import AdminSidebar from '@/components/layout/AdminSidebar'
import ProtectedRoute from '@/components/auth/ProtectedRoute'
import PageLayout from '@/components/layout/PageLayout'

export const Route = createFileRoute('/_protected/profile')({
    component: () => (
        <ProtectedRoute>
            <PageLayout>
                <div className="flex h-screen">
                    <AdminSidebar />
                    <main className="flex-1 overflow-auto">
                        <Profile />
                    </main>
                </div>
            </PageLayout>
        </ProtectedRoute>
    ),
})
